import './CheckboxGroupFilter.css';

const LevelBadge = ({ requiredLevel, userLevel, isLoggedIn }) => {
  if (!isLoggedIn) {
    return <span className="level-badge login-required">Login Required</span>;
  }
  if (userLevel < requiredLevel) {
    return <span className="level-badge">Level {requiredLevel}+</span>;
  }
  return null;
};

const CheckboxGroupFilter = ({ 
  label, 
  options, 
  selectedValues, 
  onChange,
  disabled = false,
  requiredLevel,
  userLevel,
  isLoggedIn
}) => {
  return (
    <div className="filter-group">
      <label>
        <span>{label}</span>
        {requiredLevel !== undefined && (
          <LevelBadge requiredLevel={requiredLevel} userLevel={userLevel} isLoggedIn={isLoggedIn} />
        )}
      </label>
      <div className="checkbox-group">
        {options.map(option => (
          <label key={option.value} className="checkbox-label">
            <input
              type="checkbox"
              checked={selectedValues.includes(option.value)}
              onChange={(e) => onChange(option.value, e.target.checked)}
              disabled={disabled}
            />
            {option.label}
          </label>
        ))}
      </div>
    </div>
  );
};

export default CheckboxGroupFilter;
